import './style.scss';
import template from './saveEmployment.html';

export default {
  template,
  bindings: {
    isSavingEmployment: '<',
  },
};
